import { useMemo } from 'react';

import { Logger } from './Logger';

/**
 * Create logger and memoize it in current component context.
 *
 * @param prefix - prefix for logging
 * @param enabled - whether logging is enabled
 * @returns new memoized logger instance
 */
export function useLogger(prefix: string, enabled?: boolean): Logger {
  return useMemo(() => new Logger(prefix, enabled), [prefix, enabled]);
}
